import { deleteField } from 'firebase/firestore';
import { deleteObject, getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

import { taskApi } from 'api';
import { MyRef, myStorage } from 'Common/Firebase';

async function addWord(file: File, currentICLId: string, taskId: string, isStudent?: boolean) {
  const newId = uuidv4();
  const fileNameWithId = `id-${newId}-${file.name}`; // each file name in storage must have a unique name otherwise it is not possible to add two different files with the same name

  const storageRef = MyRef(myStorage, 'Word/' + fileNameWithId);

  const snapshot = await uploadBytes(storageRef, file);
  const wordUrl = await getDownloadURL(snapshot.ref);

  isStudent
    ? await taskApi.updateTask(currentICLId, { id: taskId, studentWordUrl: wordUrl })
    : await taskApi.updateTask(currentICLId, { id: taskId, wordUrl });

  return wordUrl;
}

async function removeWord(wordUrl: string, currentICLId: string, taskId: string, isStudent?: boolean) {
  const fileRef = ref(myStorage, wordUrl);

  await deleteObject(fileRef);

  isStudent
    ? await taskApi.updateTask(currentICLId, { id: taskId, studentWordUrl: deleteField() })
    : await taskApi.updateTask(currentICLId, { id: taskId, wordUrl: deleteField() });
}

export const wordApi = {
  addWord,
  removeWord,
};
